import { validationMixin } from "vuelidate";
import { email, maxLength, required } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
import { emailFormatter } from "@/mixins/validation";

export default {
    name: "restore-password",
    mixins: [validationMixin],
    data() {
        return {
            validationErrors: {},
            step: 1,
            payload: {
                email: "",
            },
        };
    },
    validations: {
        payload: {
            email: {
                required,
                email: (val) => email(emailFormatter(val)),
                maxLength: maxLength(50),
            },
        },
    },

    computed: {
        emailErrors() {
            let error = [];
            if (!this.$v.payload.email.$dirty) {
                return error;
            }
            if (!this.$v.payload.email.required) {
                // error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.email.email) {
                error.push(this.$t("validationEmail"));
            }
            if (!this.$v.payload.email.maxLength) {
                error.push(
                    this.$t("maxLengthField")
                        .replace(":field", this.$t("emailFieldShort"))
                        .replace(":count", 50)
                );
            }
            if (this.validationErrors.email) {
                this.validationErrors.email.forEach((row) => {
                    error.push(row);
                });
            }
            return error;
        },
        ...mapGetters({
            loading: "auth/loadingRestorePassword",
        }),
    },
    methods: {
        ...mapActions({
            restore: "auth/AUTH_RESTORE_PASSWORD",
        }),
        resetForm() {
            this.$v.$reset();
            this.payload.email = "";
        },
        encryptionEmail() {
            let email = this.payload.email;
            let firstDot = false;
            const emailLength = email.length;
            const emailArr = Array.from(email).reverse();
            const replacedArr = emailArr.map((e, i) => {
                if (e === ".") {
                    if (!firstDot) {
                        firstDot = true;
                        return ".";
                    } else {
                        return e;
                    }
                } else {
                    if (!firstDot) {
                        return e;
                    }
                    if (e === "@") {
                        return "@";
                    }
                    if (i === emailLength - 1) {
                        return email.charAt(0);
                    }
                    return "●";
                }
            });
            const reverseArr = replacedArr.reverse();
            const finalChange = `<span>${reverseArr.join("")}</span>`;
            return `${this.$t("restorePasswordSuccess").replace(":email", finalChange)}`;
        },
        submit() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.restore(this.payload)
                    .then(() => {
                        this.encryptionEmail();
                        this.step = 2;
                    })
                    .catch((error) => {
                        if (error.response.status === 422) {
                            this.validationErrors = error.response.data.validation;
                        }
                    });
            }
        },
    },
};
